/**
 * @fileoverview DELETE handler for the "/alloys/partners/google-postmaster/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { deleteAlloysPartnersGooglePostmasterAppGroupIdCacheKeys } from "./constants";
import type {
  DeleteAlloysPartnersGooglePostmasterAppGroupIdProps,
  DeleteAlloysPartnersGooglePostmasterAppGroupIdResult,
} from "./types";

export const deleteAlloysPartnersGooglePostmasterAppGroupId = reactQueryMutationAdapter(
  deleteAlloysPartnersGooglePostmasterAppGroupIdCacheKeys,
  (
    props: DeleteAlloysPartnersGooglePostmasterAppGroupIdProps
  ): Promise<DeleteAlloysPartnersGooglePostmasterAppGroupIdResult> => {
    return fetch(`/alloys/partners/google-postmaster/${props.appGroupId}`, "DELETE", {}, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
